import React, { useState, useEffect } from 'react'
import { Link, NavLink, useNavigate } from "react-router-dom";
import Logo from "../assets/images/newlogo.png"
// import Headerimg from "../assets/images/home.png"
import { Loader } from "react-overlay-loader"
import { axiosInstance } from '../config/https'
import { BaseUrl } from "../baseurl/Baseurl"
import { toast } from "react-toastify";

export default function Header2() {
    const navigate = useNavigate();
    const Token = localStorage.getItem("Token");
    // console.log("Token", Token)
    const [loader, setLoader] = useState(false);
    const [fname, setFname] = useState("");
    const [profileimage, setprofileimage] = useState("");

    const Logout = () => {
        localStorage.clear();
        navigate("/Login");
    }

    useEffect(() => {
        if (Token != null) {
            GetProfile();
        }
    }, [Token])


    const GetProfile = () => {
        setLoader(true)
        axiosInstance.get("user/profile")
            .then((response) => {
                setLoader(false)
                if (response?.data?.status) {
                    setFname(response.data.data.fname)
                    // setLname(response.data.data.lname)
                    // setEmail(response.data.data.email)
                    // setAddress(response.data.data.address)
                    // setContact(response.data.data.contact)
                    setprofileimage(response.data.data.profile);
                    // console.log("response.data", response.data.data)
                }else {
                    toast.warning(response?.data?.message)
        
        
                  }
                }).catch(() => {
                  setLoader(false)
            })
    }

    return (
        <div>
            {loader === true ? <Loader fullPage loading /> : null}
            <nav
                className="navbar navbar-expand-lg fixed-top navbar-white navbar-custom sticky"
                id="navbar"
            >
                <div className="container">
                    {/* LOGO */}
                    <Link className="navbar-brand text-uppercase" to="/">
                        <img src={Logo} alt="" height={45} />
                    </Link>
                    <button
                        className="navbar-toggler"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#navbarCollapse"
                        aria-controls="navbarCollapse"
                        aria-expanded="false"
                        aria-label="Toggle navigation"
                    >
                        <span className="mdi mdi-menu" />
                    </button>
                    <div className="collapse navbar-collapse" id="navbarCollapse">
                        <ul className="navbar-nav mx-auto" id="navbar-navlist">
                            <li className="nav-item">
                                <NavLink className={({ isActive }) =>
                                    isActive ? "nav-link active" : "nav-link"
                                } to="/">
                                    Home
                                </NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink className={({ isActive }) =>
                                    isActive ? "nav-link active" : "nav-link"
                                } to="/HowitsWork">
                                    How It Works
                                </NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink className={({ isActive }) =>
                                    isActive ? "nav-link active" : "nav-link"
                                } to="/Review">
                                    Reviews
                                </NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink className={({ isActive }) =>
                                    isActive ? "nav-link active" : "nav-link"
                                } to="/Pricing">
                                    Pricing
                                </NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink className={({ isActive }) =>
                                    isActive ? "nav-link active" : "nav-link"
                                } to="/Faq">
                                    Faq's
                                </NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink className={({ isActive }) =>
                                    isActive ? "nav-link active" : "nav-link"
                                } to="/Articles">
                                    Articles
                                </NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink className={({ isActive }) =>
                                    isActive ? "nav-link active" : "nav-link"
                                } to="/Blogs">
                                    Blogs
                                </NavLink>
                            </li>
                        </ul>
                        {Token == null ?
                            <div className="d-flex align-items-center">
                                <Link className="nav-link text-white" to="/Login" style={{ fontFamily: "Poppins", fontWeight: "700", fontSize: "18px" }}>
                                    LOG IN
                                </Link>
                                <Link to="/Signup">
                                    <div className="abc">
                                        <spna className="abcc">
                                            GET STARTED
                                        </spna>
                                    </div>
                                </Link>
                            </div> :
                            <div className="d-flex align-items-center">
                                <div className=" flex-shrink-0 d-none d-lg-block">
                                    <img className="rounded-circle header-profile-user" src={BaseUrl.imageURL + profileimage} style={{ minWidth: "70px", maxWidth: "40px", borderRadius: "20px" }} alt='' />
                                </div>
                                <span className="nav-link text-white" >
                                    Welcome {fname}
                                </span>

                                <div className=" flex-shrink-0 d-none d-lg-block">
                                    <Link onClick={Logout} k to="/Login">
                                        <div className="abc">
                                            <spna className="abcc">
                                                LOGOUT
                                            </spna>
                                        </div>
                                    </Link>

                                    {/* <button className="btn btn-outline-primary " onClick={Logout} >
                                        Logout
                                    </button> */}
                                </div>

                            </div>}
                    </div>
                </div>
            </nav>
            {/* Start Home  */}

            {/* <!-- End Home --> */}


        </div>
    )
}
